(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  function openRingSizeAnswer() {
    if (window.location.hash !== '#ringmaat') return;
    const trigger = document.querySelector('[data-ofk-ring-size-trigger]');
    if (trigger && !trigger.classList.contains('is-open')) trigger.click();
  }
  document.addEventListener('page:loaded', openRingSizeAnswer);
  window.addEventListener('load', openRingSizeAnswer);
  window.addEventListener('hashchange', openRingSizeAnswer);
  document.addEventListener('shopify:section:load', openRingSizeAnswer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofk-ring-size-faq"] && !Shopify.designMode) return;
  try {
    
  function openRingSizeAnswer() {
    if (window.location.hash !== '#ringmaat') return;
    const trigger = document.querySelector('[data-ofk-ring-size-trigger]');
    if (trigger && !trigger.classList.contains('is-open')) trigger.click();
  }
  document.addEventListener('page:loaded', openRingSizeAnswer);
  window.addEventListener('load', openRingSizeAnswer);
  window.addEventListener('hashchange', openRingSizeAnswer);
  document.addEventListener('shopify:section:load', openRingSizeAnswer);

  } catch(e) { console.error(e); }
})();
})();
